import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import lessonServices from "../../../services/lessonServices";
import Button from "../../Button";
import LoadingSpinner from "../../LoadingSpinner";
import Modal from "../../Modal";

const TeachersGuideModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [guides, setGuides] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal(selectedLessonID) {
      setIsOpen(true);
      fetchGuides(selectedLessonID);
    },
    closeModal() {
      setIsOpen(false);
      setGuides([]);
    },
  }));

  const handleCloseModal = () => {
    setGuides([]);
    setIsOpen(false);
  };

  const fetchGuides = async (lessonID) => {
    setIsLoading(true);
    try {
      const response = await lessonServices.getGuides(lessonID); // Rename method accordingly
      setGuides(response?.guides || []);
    } catch (error) {
      console.error("Error fetching guides:", error);
      setGuides([]);
    }
    setIsLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal}>
      {isLoading ? (
        <div className="flex items-center justify-center py-5">
          <LoadingSpinner color="green" />
        </div>
      ) : guides.length > 0 ? (
        <div className="space-y-4">
          {guides.map((guide, index) => (
            <div
              key={index}
              className="rounded-lg border border-gray-200 p-4 shadow-sm transition hover:shadow-md"
            >
              <h3 className="text-lg font-semibold">{guide.title}</h3>
              {guide.description && <p className="mt-1 text-sm text-gray-600">{guide.description}</p>}
              <div className="mt-3">
                {guide.url && (
                  <a href={guide.url} target="_blank" rel="noopener noreferrer">
                    <Button>{t("view_guide")}</Button>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="flex min-h-[45vh] items-center justify-center text-center text-gray-500">
          {t("no_guides_available")}
        </p>
      )}
    </Modal>
  );
});

export default TeachersGuideModal;
